<!-- 
NotApplyForCWPDataTable.vue
功能：未申辦 「FitBack健康吧」 名單DataTable
作者：i9400538 陳博承
完成：2021-04-20
-->
<template>
  <section class="newTable">
    <table class="table datatable table-striped area-list-datatable" id="NotApplyForCWPDataTable">
      <thead>
        <tr>
          <th id="th_sel" :width="screenWidth * 0.08">
            <div class="checkbox checkbox-inline mr-0">
              <input
                @click="clickTarget = clickTarget == `clickAll`? `clickAll-again`: `clickAll`"
                type="checkbox"
                name="check-all"
                id="check-all"
                value="1"
                v-model="checkAll"
              />
              <label for="check-all"></label>
            </div>
            <span>#</span>
          </th>
          <th
            id="th_name"
            :width="screenWidth * 0.09"
            :class="'sorting ' + (order.fieldName == 'name' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('name')"
          >姓名</th>
          <th
            id="th_id"
            :width="screenWidth * 0.09"
            :class="'sorting ' + (order.fieldName == 'id' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('id')"
          >身分證</th>
          <th
            id="mobile"
            :width="screenWidth * 0.09"
            :class="'sorting ' + (order.fieldName == 'mobile' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('mobile')"
          >手機</th>
          <th
            id="th_insd"
            :width="screenWidth * 0.1"
            :class="'sorting ' + (order.fieldName == 'insd' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('insd')"
          >是否為外溢計步保單被保人</th>
          <th
            id="th_member"
            :width="screenWidth * 0.12"
            :class="'sorting ' + (order.fieldName == 'member' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('member')"
          >是否為官網會員</th>
          <th id="th_sharelink">分享活動連結</th>
          <th id="th_visit" width="148">排訪</th>
        </tr>
      </thead>
      <tbody class="block-height" :style="{height: height + 'px'}">
        <tr v-for="(d, did) in tableDataBackup" :key="`NotApplyForCWPDataTable-table-td-${did}`">
          <td :width="screenWidth * 0.08">
            <div style="min-height: 30px;">
              <div class="mr-0 checkbox checkbox-inline">
                <input
                  @click="clickTarget = clickTarget == `td-${did}`? `td-${did}-again`: `td-${did}`"
                  type="checkbox"
                  name="`td-item[]`"
                  :id="`NotApplyForCWPDataTable-check-${did}`"
                  :value="d.id"
                  v-model="selection"
                  :disabled="d.id === ''"
                  @change="$emit('update', selection)"
                />
                <label :for="`NotApplyForCWPDataTable-check-${did}`"></label>
              </div>
              <span>
                <span class="no">{{did + 1}}</span>
                <span class="info text-center">
                  <level :lv="Number(d.vip_level)" />
                  <avatar :gender="Number(d.sex)" :size="20" />
                </span>
              </span>
            </div>
          </td>
          <td :width="screenWidth * 0.09">
            <Tooltip
              :position="did < 3 ? 'bottom' : 'top'"
              :id="d.id"
              :name="d.name"
              :mobile="d.mobile"
            >
              <a
                v-if="d.is_exist"
                class="text-green text-underline pointer-cursor"
                @click="routerToCust(d.id, d.name)"
              >{{d.name | getMaskName}}</a>
              <a v-else>{{d.name | getMaskName}}</a>
            </Tooltip>
          </td>
          <td :width="screenWidth * 0.09">{{d.id | getMaskID }}</td>
          <td :width="screenWidth * 0.09">{{d.mobile | getMaskMobile}}</td>
          <td :width="screenWidth * 0.1">{{d.insd}}</td>
          <td :width="screenWidth * 0.12">{{d.member}}</td>
          <td>
            <div class="board-body">
              <div class="list video" style="padding:0px 0px">
                <div class="item" style="padding:0px 0px">
                  <div class="content">
                    <div class="action">
                      <button
                        type="button"
                        class="btn btn-default btn-sm"
                        @click="copy(mmlUrl)"
                      >複製連結</button>
                      <i
                        class="icon-facebook"
                        style="cursor:pointer;"
                        @click="encodeLink('fb', fbMetaUrl)"
                      ></i>

                      <i
                        class="icon-line"
                        style="cursor:pointer;"
                        @click="encodeLink('line', mmlUrl)"
                      ></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </td>
          <td v-if="isBox" :width="iPadWidth">
            <button
              type="button"
              v-if="!d.visit.csidno"
              class="btn btn-primary"
              @click="callBoxVisit(d)"
              v-html="'<span style=\'font-size:1.25rem\'>預約<span>'"
            ></button>
            <button
              type="button"
              v-else
              class="btn btn-primary"
              style="font-size:0.8rem;"
              @click="callBoxVisit(d)"
            >
              {{ d.visit.str_date | dateFormat }}
              <br />
              {{ d.visit.str_time }}
            </button>
          </td>
          <td v-else :width="iPadWidth">
            <button
              type="button"
              v-if="!d.visit.csidno"
              class="btn btn-primary"
              @click="$emit('scheduled-access', d)"
              v-html="'<span style=\'font-size:1.25rem\'>預約<span>'"
            ></button>
            <button
              type="button"
              v-else
              class="btn btn-primary"
              style="font-size:0.8rem;"
              @click="$emit('scheduled-access', d)"
            >
              {{ d.visit.str_date | dateFormat }}
              <br />
              {{ d.visit.str_time }}
            </button>
          </td>
        </tr>
        <tr v-if="tableDataBackup.length == 0">
          <td colspan="7" class="text-center pt-3 pb-5">
            <h3>無客戶名單資料</h3>
          </td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
        </tr>
      </tbody>
    </table>
    <input type="text" style="position:absolute;left:-10000px;top:-10000px" id="copyText" />
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Level from "@/components/Level";
import Avatar from "@/components/Avatar";
import { commonMixin } from "@/mixins/common";
import { setTimeout } from "timers";
import Tooltip from "@/desktop/components/ToolTip";

const is_iPad = navigator.userAgent.match(/iPad/i) != null; // 確認裝置是否為 iPad
let idmarkWidth = 148;
if (is_iPad) {
  idmarkWidth = 131;
}

export default {
  name: "NotApplyForCWPDataTable",
  mixins: [commonMixin],
  components: { Level, Avatar, Tooltip },
  props: {
    tableData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    height: {
      type: Number,
      default: () => {
        return 350;
      }
    },
    //名單專區資訊
    categoryInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    mmlUrl: {
      type: String,
      default: ""
    },
    fbMetaUrl: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      order: {
        fieldName: "name",
        asc: true
      },
      checkAll: false,
      clickTarget: "",
      tableDataBackup: [],
      allIdData: [],
      selection: [],
      currentWidth: 0,
      is_iPad: is_iPad,
      iPadWidth: idmarkWidth,
      screenWidth:
        document.body.clientWidth > 1208 ? 1280 : document.body.clientWidth
    };
  },
  computed: {
    ...mapGetters(["UserInfo"]),
    isBox() {
      //判斷是否為box
      return this.UserInfo.userType === "box";
    }
  },
  watch: {
    tableData: function() {
      this.init();
    },
    clickTarget: function(target) {
      if (target == "clickAll" || target == "clickAll-again") {
        //點了全選checkbox
        if (this.checkAll) {
          //點了全選
          this.selection = [];
          this.allIdData.forEach(data => {
            this.selection.push(data);
          });
        } else {
          //取消全選
          this.selection = [];
        }
      } else {
        //點了其他checkbox
        this.checkAll = this.selection.length == this.allIdData.length;
      }
      this.$emit("update", this.selection);
    }
  },
  methods: {
    ...mapActions(["setPageLock", "updateCustID"]),
    columnSorting(fieldName) {
      console.log(`>>>>> columnSorting:${fieldName} <<<<<`);
      //切換表頭圖案
      if (this.order.fieldName == fieldName) {
        this.order.asc = !this.order.asc;
      } else {
        console.log("change sort field");
        this.order.fieldName = fieldName;
        this.order.asc = true;
        console.log(this.order);
      }

      //data排序
      let sortOrder = -1;
      if (this.order.asc) {
        sortOrder = 1;
      }
      switch (fieldName) {
        case "birthday":
          this.tableDataBackup = [];
          setTimeout(() => {
            this.tableDataBackup = [...this.tableData];
            this.tableDataBackup.sort(
              this.dateCompareFun(sortOrder, fieldName)
            );
            this.registerHanlink(); // for 難字更新
          }, 20);
          break;
        default:
          this.tableDataBackup = [];
          setTimeout(() => {
            this.tableDataBackup = [...this.tableData];
            this.tableDataBackup.sort(
              this.sortCompareFun(sortOrder, fieldName)
            );
            this.registerHanlink(); // for 難字更新
          }, 20);
      }
    },
    dateCompareFun(sortOrder, property) {
      return function(a, b) {
        let date_a = new Date(
          a[property] ? a[property] : "1880-01-01"
        ).getTime();
        let date_b = new Date(
          b[property] ? b[property] : "1880-01-01"
        ).getTime();
        let result = date_a < date_b ? -1 : 1;
        return result * sortOrder;
      };
    },
    sortCompareFun(sortOrder, property) {
      return function(a, b) {
        let result =
          a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
        return result * sortOrder;
      };
    },
    routerToCust(custID, custName) {
      if (this.isBox) {
        //若内嵌於Box, 將客戶資訊回傳給Box
        this.boxCustInfo(custID, custName);
      } else {
        this.updateCustID(custID);
        localStorage.CustID = custID;
        this.$router.push({ path: `/detail/CustID/tab/1` });
      }
    },
    init() {
      this.checkAll = false;
      this.selection = [];
      this.tableDataBackup = this.tableData.map(ele => {
        return ele;
      });
      this.allIdData = this.tableData.map(ele => {
        return ele.id;
      });
      this.order.fieldName = "name";
      this.order.asc = true;
      this.registerHanlink(); // for hard word
    },
    //連至Box排訪
    callBoxVisit(data) {
      this.boxVisit(data, this.categoryInfo);
    },
    //判斷是line還是FB
    encodeLink(type, link) {
      if (this.isBox) {
        this.boxCathayShareLink(link);
      } else {
        let str = encodeURI(link);
        let url =
          type === "fb"
            ? `http://www.facebook.com/share.php?u=${str}`
            : `http://line.naver.jp/R/msg/text/?${str}`;
        window.open(url);
      }
    },
    //複製連結
    copy(url) {
      if (this.isBox) {
        this.boxCathayShareLink(url);
      } else {
        const copyText = document.getElementById("copyText");
        copyText.value = url;
        copyText.select();
        copyText.setSelectionRange(0, 99999);
        if (document.execCommand("cut")) {
          this.$toast.info({ title: "連結已複製" });
        } else {
          console.error("複製失敗");
        }
      }
    }
  },
  mounted() {
    // 監聽視窗寬度
    const self = this;

    window.onresize = () => {
      return (() => {
        if (document.body.clientWidth > 1220) {
          window.screenWidth = 1220;
          self.screenWidth = 1220;
        } else {
          window.screenWidth = document.body.clientWidth;
          self.screenWidth = window.screenWidth;
        }
      })();
    };

    this.currentWidth =
      this.$el.clientWidth * (this.$el.clientWidth < 1250 ? 0.95 : 1);
    if (!is_iPad) {
      this.iPadWidth = "131";
    } else {
      this.iPadWidth = "148";
    }
  }
};
</script>

<style lang="scss" scoped>
.newTable thead tr,
.newTable tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
  border-left: 0;
  border-right: 0;
  border-bottom: 0;

  td {
    word-break: break-all;
  }

  &.sorting,
  &.sorting_desc {
    position: relative;
    padding-right: 25px !important;

    &:before,
    &:after {
      content: "";
      position: absolute;
      width: 0px;
      height: 0px;
      display: block;
      top: 0;
      bottom: 0;
      right: 6px;
      margin: auto;
    }

    &:after {
      top: 18px;
      border-top: 6px solid transparentize(#027a39, 0.5);
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-bottom: 6px solid transparent;
    }

    &:before {
      top: -13px;
      border-bottom: 6px solid transparentize(#027a39, 0.5);
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 6px solid transparent;
    }
  }

  &.sorting_asc:before {
    border-bottom: 6px solid transparentize(white, 0.5);
  }

  &.sorting_desc:after {
    border-top: 6px solid transparentize(white, 0.5);
  }

  &.no-sort:before,
  &.no-sort:after {
    display: none;
  }
}

.newTable tbody.block-height {
  display: block;
  height: 350px;
  overflow-y: scroll;
  border: 0 !important;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    width: 17px;
    border: 0;
    box-shadow: none;
  }

  &::-webkit-scrollbar-track {
    box-shadow: none;
    border-radius: 0px;
    border: 0;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    width: 10px;
    border-radius: 20px;
    background-color: #555;
  }
}
</style>
